/**
 * Progressive enhancement for sections/sticky-purchase-bar.liquid (C-013).
 * Ports reference-react/src/pages/HomePage.tsx's IntersectionObserver rule
 * (visible only after the shop section's purchase controls have been seen
 * in the viewport and then scrolled above it) and
 * reference-react/src/components/StickyPurchaseBar.tsx's add-to-cart action.
 *
 * Stays in sync with the currently selected variant by reading the single
 * product form's live DOM after assets/product-form.js completes a Section
 * Rendering API variant swap (`product-form:variant-changed`) -- no second
 * fetch. Hidden while the cart drawer is open (#cart-drawer[hidden]).
 */
(function () {
  if (window.CremapuraStickyBar) return;

  var SUCCESS_REVERT_MS = 2000;
  var NAME_PLACEHOLDER = '%%NAME%%';

  var bar = document.getElementById('sticky-purchase-bar');
  if (!bar) return;

  var hasBeenSeen = false;
  var intersectionVisible = false;
  var observer = null;
  var observedEl = null;

  function currentFormWrapper() {
    return document.querySelector('[data-product-form]');
  }

  function isCartOpen() {
    var drawer = document.getElementById('cart-drawer');
    return !!drawer && !drawer.hasAttribute('hidden');
  }

  function isPurchasable() {
    var wrapper = currentFormWrapper();
    return !!(wrapper && wrapper.querySelector('[data-product-form-submit]'));
  }

  function applyVisibility() {
    var shouldShow = intersectionVisible && !isCartOpen() && isPurchasable();
    bar.hidden = !shouldShow;
  }

  function handleIntersect(entries) {
    var entry = entries[0];
    if (entry.isIntersecting) {
      hasBeenSeen = true;
      intersectionVisible = false;
    } else if (hasBeenSeen) {
      intersectionVisible = entry.boundingClientRect.top < 0;
    } else {
      intersectionVisible = false;
    }
    applyVisibility();
  }

  function attachObserver() {
    var wrapper = currentFormWrapper();
    var anchor = wrapper && wrapper.querySelector('[data-product-form-purchase]');
    if (!anchor || anchor === observedEl) return;

    if (observer) observer.disconnect();
    observedEl = anchor;
    observer = new IntersectionObserver(handleIntersect, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    observer.observe(anchor);
  }

  function syncFromForm() {
    var wrapper = currentFormWrapper();
    if (!wrapper) return;

    var variantIdInput = wrapper.querySelector('[data-product-form-variant-id]');
    var priceEl = wrapper.querySelector('[data-product-form-total-price]');
    var selectedOption = wrapper.querySelector('.product-form__option-row--selected .product-form__option-name');
    var isAvailable = isPurchasable();

    var addBtn = document.querySelector('[data-sticky-purchase-bar-add]');
    if (addBtn) {
      if (variantIdInput) addBtn.setAttribute('data-variant-id', variantIdInput.value);
      addBtn.disabled = !isAvailable;
    }

    var titleEl = document.querySelector('[data-sticky-purchase-bar-title]');
    if (titleEl && selectedOption) {
      var template = titleEl.getAttribute('data-title-template');
      if (template) titleEl.textContent = template.replace(NAME_PLACEHOLDER, selectedOption.textContent.trim());
    }

    var priceOut = document.querySelector('[data-sticky-purchase-bar-price]');
    if (priceOut && priceEl) {
      priceOut.textContent = priceEl.textContent.trim();
    }

    var section = wrapper.closest('.shopify-section, section');
    var imgSource = section && section.querySelector('.product-shop__image, .product-shop__image-placeholder');
    var frame = document.querySelector('[data-sticky-purchase-bar-image-frame]');
    if (frame && imgSource) {
      frame.replaceChildren(imgSource.cloneNode(true));
    }

    applyVisibility();
  }

  function setAddButtonState(btn, state) {
    btn.dataset.state = state;
    var label = btn.querySelector('[data-sticky-purchase-bar-add-label]');
    if (!label) return;
    var attr = state === 'success' ? 'data-label-success' : 'data-label-idle';
    label.textContent = btn.getAttribute(attr) || '';
  }

  function handleAddClick(event) {
    var btn = event.currentTarget;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || !window.CremapuraCart || btn.disabled) return;

    btn.disabled = true;
    window.CremapuraCart.addItem(variantId, 1).then(function (result) {
      btn.disabled = false;
      if (result) {
        setAddButtonState(btn, 'success');
        window.setTimeout(function () {
          setAddButtonState(btn, 'idle');
        }, SUCCESS_REVERT_MS);
      }
    });
  }

  function setup() {
    attachObserver();
    syncFromForm();

    document.addEventListener('product-form:variant-changed', function () {
      syncFromForm();
      attachObserver();
    });

    var addBtn = document.querySelector('[data-sticky-purchase-bar-add]');
    if (addBtn) addBtn.addEventListener('click', handleAddClick);

    var cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer && window.MutationObserver) {
      new MutationObserver(applyVisibility).observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['hidden']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  window.CremapuraStickyBar = { applyVisibility: applyVisibility };
})();
